import './Box.css';

import PropTypes from 'prop-types';

const Box = ({ className, id, children }) => (
  <div className={className ? `${className} box-container` : 'box-container'} id={id}>
    {children || null}
  </div>
);

Box.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  className: PropTypes.string
};

export default Box;
